import {useContext} from 'react';
import {Link, SubLink} from 'react-router-dom';
import { useRef } from 'react';
import NavigationComponent from '../navigation/navigation.component';
import { Background, OppGradient, Paragraph, IF, Padding, IconContainer, Icon, SocialLink} from './contactme.styles';
import bluesky from '../images/social-icons/bluesky-icon.png';
import caard from '../images/social-icons/carrd-icon.png';
const ContactMeComponent = () => {

    return (
       <Background>
        <NavigationComponent></NavigationComponent>
        <Padding></Padding>
        <Paragraph>Feel free to check out my socials here!</Paragraph>
        <IconContainer>
            <SocialLink href="https://bsky.app/profile/brennanicki.bsky.social"><Icon src={bluesky}/></SocialLink>
            <SocialLink href="https://jellighouls.carrd.co/#"><Icon src={caard}/></SocialLink>
        </IconContainer>
        <Paragraph>Did something in my site pique your interest?  Are you interested in callobrating or commissioning me for a project/product?  Please complete the form below!  I look forward to working with you!</Paragraph>
        <IF src="https://docs.google.com/forms/d/e/1FAIpQLSf87Kmp8Ss8jxwSKXZYHVamYEWw5PtGRRESzJteyoNXxS4Hzw/viewform?embedded=true" width="640" height="1300" frameborder="0" marginheight="0" marginwidth="0" >Loading…</IF>
       </Background>
    )
}

export default ContactMeComponent;